import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MoreOptionsService {
    private moreOptionsNode = new BehaviorSubject<any>({});
    currentNode = this.moreOptionsNode.asObservable();
    constructor() { }
    setNode(obj: any) {
        this.moreOptionsNode.next(obj);
    }
}
